module.exports = __webpack_public_path__ + "static/media/16.37de7d00.png";